import React from 'react'
import { Head, router } from '@inertiajs/react'
import AdminLayout from '../../../components/AdminLayout'
import AdminTable from '../../../components/AdminTable'

interface Country {
  id: number
  name: string
  created_at: string
}

interface Props {
  countries: Country[]
  pagination: {
    current_page: number
    total_pages: number
    total_count: number
    per_page: number
    prev_page?: number
    next_page?: number
  }
  filters: {
    search?: string
  }
  can_edit: boolean
}

function CountriesIndex({ countries, pagination, filters, can_edit }: Props) {
  const columns = [
    { key: 'name', label: 'Name' },
    { key: 'created_at', label: 'Created At' },
  ]

  const formFields = [
    { name: 'name', label: 'Name', type: 'text' as const, required: true }
  ]

  const handleCreate = (formData: any) => {
    router.post('/countries', { country: formData })
  }

  const handleEdit = (item: any) => {
    const isConfirmed = window.confirm(`Are you sure you want to update the country "${item.name}"?`)
    if (isConfirmed) {
      router.put(`/countries/${item.id}`, { country: { name: item.name } })
    }
  }

  const handleDelete = (item: any) => {
    if (item.offers_count > 0) {
      alert('Cannot delete country with associated offers.')
      return
    }
    
    const isConfirmed = window.confirm(
      `Are you sure you want to delete the country "${item.name}"?\n\nThis action cannot be undone.`
    )
    if (isConfirmed) {
      router.delete(`/countries/${item.id}`)
    }
  }

  return (
    <>
      <Head title="Countries | Mailkit - Resolute" />
      <AdminTable
        title="Countries"
        description="Manage countries in the system"
        data={countries}
        columns={columns}
        pagination={pagination}
        filters={filters}
        can_edit={can_edit}
        onCreate={handleCreate}
        onEdit={handleEdit}
        onDelete={handleDelete}
        searchPlaceholder="Search countries..."
        basePath="/countries"
        formFields={formFields}
      />
    </>
  )
}

CountriesIndex.layout = page => <AdminLayout>{page}</AdminLayout>

export default CountriesIndex